/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Research_Briefing_TitleInputs */

const en_research_briefing_title = /** @type {(inputs: Research_Briefing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefing`)
};

/**
* | output |
* | --- |
* | "Briefing" |
*
* @param {Research_Briefing_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const research_briefing_title = /** @type {((inputs?: Research_Briefing_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Research_Briefing_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_research_briefing_title(inputs)
});